module.exports = __webpack_public_path__ + "img/majaal-slogan.5b520f20.png";